import { useState } from 'react'

import overviewJson from '../../demo/fixtures/w2/overview.json'
import { Button, Card, CardHead } from '../../ui'
import styles from './NoticesCard.module.css'

interface Notice {
  text: string
  time: string
}

interface OverviewFixture {
  notices: Notice[]
}

const fixture = overviewJson as unknown as OverviewFixture

export function NoticesCard() {
  const [read, setRead] = useState(false)
  return (
    <Card data-scope="overview-notices">
      <CardHead title="最近通知" action={<Button className={styles.cardLink} variant="link" disabled={read} onClick={() => setRead(true)}>全部已读</Button>} />
      {fixture.notices.map((notice) => (
        <div className={styles.row} key={notice.text}>
          {read ? null : <span className={styles.dot} />}
          <div>
            <p className={styles.text}>{notice.text}</p>
            <p className={styles.time}>{notice.time}</p>
          </div>
        </div>
      ))}
    </Card>
  )
}
